import { render } from "./AppLocale.vue?vue&type=template&id=2a7e463c&scoped=true"
import script from "./AppLocale.vue?vue&type=script&lang=js"
export * from "./AppLocale.vue?vue&type=script&lang=js"

import "./AppLocale.vue?vue&type=style&index=0&id=2a7e463c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7e463c"]])

export default __exports__